// extracted by mini-css-extract-plugin
export default {"wrapper":"gallery-image_wrapper__mRxcF","preloader":"gallery-image_preloader__jZ88v","shimmer":"gallery-image_shimmer__ZgpXU"};